import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import InputXPath from '../input/XPath';
import FormFieldBase from './FieldBase';
/**
 * @param {import('./types').FinalFormFieldXPathProps} props
 */

var FormXPath = function FormXPath(_ref) {
  var _ref$input = _ref.input,
      name = _ref$input.name,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      restInput = _objectWithoutProperties(_ref$input, ["name", "onChange", "value"]),
      meta = _ref.meta,
      rest = _objectWithoutProperties(_ref, ["input", "meta"]);

  return React.createElement(InputXPath, Object.assign({}, rest, {
    name: name,
    helperText: meta.touched ? meta.error : undefined,
    error: meta.error && meta.touched,
    inputProps: restInput,
    onChange: onChange,
    value: value
  }));
};
/**
 * @param {import('../input/types').FormInputXPathProps} props
 */


export var XPath = function XPath(_ref2) {
  var name = _ref2.name,
      path = _ref2.path,
      rest = _objectWithoutProperties(_ref2, ["name", "path"]);

  return React.createElement(FormFieldBase, Object.assign({
    name: name,
    label: name,
    path: path
  }, rest));
};
XPath.defaultProps = {
  component: FormXPath,
  workspace: 'Default'
};
export default FormXPath;